import React, { useState, useEffect } from 'react';
import ContentBox from '../../../../components/ContentBox';
import { NotificationManager } from 'react-notifications';
import UsuariosService from 'services/UsuariosService';
import AgendamentosLicenciamentoService from 'services/AgendamentosLicenciamentoService';
import AssinaturasService from 'services/AssinaturasService';
import useBloqueio from 'hooks/useBloqueio';
import { FuncionalidadePortalCliente } from 'constants/funcionalidadePortalCliente';
import { ModalInformativo } from 'components/Modais/ModalInformativo';
import { Container, Content } from '../componentes/confirmationAlterPlan/styles';

const LicenciamentoAutomatico = ({ 
  usuarioId, 
  planoAtual,
  planoSelecionado,
  produtosOpcionaisSelecionados,
  considerarJanelaCancelamento,
  onSuccess,
  onCancel,
  onError,
  onFinalizacao,
  onLoading,
  setEsconderBotaoProximo,
  setDesativarBotaoVoltar,
  checarSePlanoFoiAlterado
}) => {
  const [loading, setLoading] = useState(true);
  const [trocaImediataDisponivel, setTrocaImediataDisponivel] = useState(false);
  const { bloqueado: execucaoImediataBloqueada, mensagem: mensagemBloqueioAlteracaoPlano } = useBloqueio(FuncionalidadePortalCliente.AlteracaoPlanoUsuario);

  useEffect(() => {
    setEsconderBotaoProximo(true);
    setDesativarBotaoVoltar(true);
    checarCondicaoLicenciamento();
  }, []);

  const ehPrimeiroDiaDoMes = () => {
    const today = new Date();
    return today.getDate() === 1;
  };

  const obterPrimeiroDiaProximoMes = () => {
    const today = new Date();
    const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
    return nextMonth;
  };

  const formatarNomeDoMes = (date) => {
    return new Intl.DateTimeFormat('pt-BR', { month: 'long', year: 'numeric' }).format(date);
  };

  const disponibilizarTrocaImediata = () => {
    setTrocaImediataDisponivel(true);
    setEsconderBotaoProximo(false);
  };

  const indisponibilizarTrocaImediata = () => {
    setTrocaImediataDisponivel(false);
    setEsconderBotaoProximo(true);
  };

  const gerarBodyValidacaoJanelaCancelamento = () => {
    const signature = JSON.parse(sessionStorage.getItem("signature"));
    const validationData = {
      tenantId: signature.axtTenantId,
      tenantCode: signature.tenantCode || "",
      produtoId: planoAtual?.produtoAssociadoId || "",
      unidadeId: planoAtual?.unidadeId || ""
    };
    return validationData;
  };

  const checarCondicaoLicenciamento = async () => {
    try {
      if (!checarSePlanoFoiAlterado()) {
        disponibilizarTrocaImediata();
        return;
      }

      if (considerarJanelaCancelamento === true) {
        const validationData = gerarBodyValidacaoJanelaCancelamento();
        try {
          await AssinaturasService.ValidarSeLicencaDentroDaJanelaCancelamento(validationData);
          disponibilizarTrocaImediata();
          return;
        } 
        catch (err) {}
      } 
      else {
        if (ehPrimeiroDiaDoMes()) {
          disponibilizarTrocaImediata();
          return;
        }
      }

      indisponibilizarTrocaImediata();
    } catch (err) {
      NotificationManager.error('Erro ao verificar condições de licenciamento.');
      setEsconderBotaoProximo(false);
      onCancel();
    } finally {
      setDesativarBotaoVoltar(false);
      setLoading(false);
    }
  };

  const handleExecutarAgora = async () => {
    if (execucaoImediataBloqueada) {
      ModalInformativo('Alteração de plano indisponível', mensagemBloqueioAlteracaoPlano);
      return;
    }

    onLoading(true);
    try {
      const signature = JSON.parse(sessionStorage.getItem("signature"));
      const userData = {
        UsuarioId: usuarioId,
        TenantId: signature.axtTenantId,
        DireitoId: signature.entitlementId,
        ProdutoPrincipal: {
          ProdutoPrincipalId: planoSelecionado.value,
          UnidadePrincipalId: planoSelecionado.UnidadePrincipalId
        },
        ProdutosOpcionais: produtosOpcionaisSelecionados.map(addon => ({
          ProdutoId: addon.value,
          UnidadeId: addon.UnidadeId
        }))
      };

      const response = await UsuariosService.EditarLicenciamento(userData);
      onSuccess(response);
    } catch (error) {
      onError(error.response?.data?.erros ?? ['Erro ao tentar editar o licenciamento do usuário.']);
    } finally {
      onFinalizacao();
    }
  };

  const handleAgendarParaProximoMes = async () => {
    onLoading();
    try {
      const signature = JSON.parse(sessionStorage.getItem("signature"));
      const contact = JSON.parse(sessionStorage.getItem("contact"));
      const nextMonthFirstDay = obterPrimeiroDiaProximoMes();

      const scheduleData = {
        usuarioId: usuarioId,
        tenantId: signature.axtTenantId,
        tenantCode: signature.tenantCode || "",
        clienteId: signature.accountId || "",
        direitoId: signature.entitlementId,
        contatoId: contact.idContact || "",
        dataAgendada: nextMonthFirstDay.toISOString(),
        produtoPrincipal: {
          ProdutoPrincipalId: planoSelecionado.value,
          UnidadePrincipalId: planoSelecionado.UnidadePrincipalId
        },
        produtosOpcionais: produtosOpcionaisSelecionados.map(addon => ({
          ProdutoId: addon.value,
          UnidadeId: addon.UnidadeId
        }))
      };

      await AgendamentosLicenciamentoService.CriarAgendamento(scheduleData);
      onSuccess('Licenciamento agendado para o primeiro dia do próximo mês!');
    } catch (err) {
      onError(err.response?.data?.erros ?? ['Erro ao tentar agendar o licenciamento do usuário.']);
    } finally {
      onFinalizacao();
    }
  };

  if (loading) {
    return (
      <div className="small-loading">
        <div className="simple-loading"></div>
      </div>
    );
  }

  const nomeProximoMes = formatarNomeDoMes(obterPrimeiroDiaProximoMes());

  return (
    <ContentBox>
      <Container>
        <Content>
          {trocaImediataDisponivel && (
            <div>
              <h2>Alteração de Licenciamento</h2>
              <br />
              <p>
                A alteração de licenciamento será executada imediatamente ao confirmar a operação.
                <br />
                <br />
              </p>
              <p>
                Qualquer dúvida, nos contate através dos canais abaixo.<br />
                <a href="mailto:atendimento@bhs.com.br" target="_blank" rel="noopener noreferrer">
                  atendimento@bhs.com.br
                </a>
                {' '}
                <br />
                <a href="tel:4000-1744" target="_blank" rel="noopener noreferrer">
                  4000-1744
                </a>
              </p>
            </div>
          )}

          {!trocaImediataDisponivel && (
            <div>
              <h2>Alteração de Licenciamento</h2>
              <br />
              <p>
                Escolha como deseja proceder com a alteração do seu licenciamento:
                <br />
                <br />
              </p>

              <div style={{ marginTop: 20, marginBottom: 20, padding: 15, backgroundColor: '#f5f5f5', borderRadius: 4 }}>
                <h4>Opção 1: Executar Agora</h4>
                <p>
                  A alteração será executada imediatamente. Você será cobrado integralmente pela licença atual e pela nova licença.
                </p>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={handleExecutarAgora}
                  disabled={execucaoImediataBloqueada}
                  style={{ marginTop: 10 }}
                >
                  {'Executar Agora'}
                </button>
                {execucaoImediataBloqueada && (
                  <p style={{ marginTop: 10, color: '#c0392b', fontSize: 12 }}>
                    {mensagemBloqueioAlteracaoPlano}
                  </p>
                )}
              </div>

              <div style={{ marginTop: 20, marginBottom: 20, padding: 15, backgroundColor: '#f5f5f5', borderRadius: 4 }}>
                <h4>Opção 2: Agendar para {nomeProximoMes}</h4>
                <p>
                  A alteração será realizada no primeiro dia do próximo mês. Você pagará apenas pela licença atual durante este mês. 
                  A nova licença será cobrada a partir do próximo mês.
                </p>
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={handleAgendarParaProximoMes}
                  style={{ marginTop: 10 }}
                >
                  {`Agendar para ${nomeProximoMes}`}
                </button>
              </div>

              <p style={{ marginTop: 30 }}>
                Qualquer dúvida, nos contate através dos canais abaixo.<br />
                <a href="mailto:atendimento@bhs.com.br" target="_blank" rel="noopener noreferrer">
                  atendimento@bhs.com.br
                </a>
                {' '}
                <br />
                <a href="tel:4000-1744" target="_blank" rel="noopener noreferrer">
                  4000-1744
                </a>
              </p>
            </div>
          )}
        </Content>
      </Container>
    </ContentBox>
  );
};

export default LicenciamentoAutomatico;
